import { Component } from '@angular/core';
import { BusinessClient, ClientType, PersonClient } from '@models/clients';
import { Select } from '@ngxs/store';
import { ClientsState } from '@state/clients';
import { EMPTY, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatterClients } from '@state/global/matter_clients';
import {
	BusinessMatterClientWithAssociations,
	MatterClientType,
	MatterFileType,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

@UntilDestroy()
@Component({
	selector: 'app-edit-client-side-form',
	templateUrl: './edit-client-side-form.component.html',
	standalone: false,
})
export class EditClientSideFormComponent {
	client$: Observable<PersonClient | BusinessClient> = EMPTY;

	public clientMatterRelationship:
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations;

	@Select(ClientsState.getClient) clientFilter$: Observable<
		(filter: string) => PersonClient
	>;

	@SelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;

	@ViewSelectSnapshot(MatterClients.get_allMatterClientsWithAssociationMapped)
	clientWithRelationships: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[];

	public clientTypes = ClientType;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
	) {
		const id = router.getCurrentNavigation()?.extras?.state?.id;
		if (!id) {
			this.router.navigate(['..'], { relativeTo: this.route });
		} else {
			this.clientMatterRelationship = this.clientWithRelationships.find(
				(x) => x.id === id,
			);
			this.client$ = this.clientFilter$.pipe(
				untilDestroyed(this),
				map((filterFn) => filterFn(id)),
			);
		}
	}

	get canBePrimaryClient() {
		return (
			(this.fileType === MatterFileType.PURCHASE &&
				this.clientMatterRelationship?.clientTypes?.includes(
					MatterClientType.BUYER,
				)) ||
			(this.fileType === MatterFileType.SALE &&
				this.clientMatterRelationship?.clientTypes?.includes(
					MatterClientType.SELLER,
				))
		);
	}
}
